// Calculate the angle of the line between the insertion point and the centroid of
// the sax endocardial contour

import { useContourContainerStore } from '@/src/store/contours/contour-container-store';
import {
  ContourLabel,
  encodeContourLabelItemId,
} from '@/src/store/contours/contour-definitions';

import { getPolygonCentroid } from './getPolygonCentroid';

export function calculateInsertionPointAngle(imageUID: string): number {
  const store = useContourContainerStore();
  const container = store.getContourContainer(imageUID);

  if (!container) return 0;

  const endoContour = container.getContour({
    label: ContourLabel.SaxLvEndo,
    id: encodeContourLabelItemId([0]),
  });
  const insertionContour = container.getContour({
    label: ContourLabel.RvInsertion,
    id: encodeContourLabelItemId([0]),
  });

  if (!endoContour || !insertionContour) return 0;

  const endoPolygon = endoContour.getPolygon();
  const insertionPolygon = insertionContour.getPolygon();

  if (endoPolygon.length < 3 || insertionPolygon.length < 1) return 0;

  const centroid = getPolygonCentroid(endoPolygon);
  const insertion = insertionPolygon[0];

  // atan2 gives angle where 0 = right (+x), π/2 = down (+y)
  // Subtract π/2 so that 0° corresponds to a vertical line (straight up from centroid)
  const rawAngle = Math.atan2(
    insertion.y - centroid.y,
    insertion.x - centroid.x,
  );
  const angle = rawAngle - -Math.PI / 2;

  // Normalize to [0, 2π)
  return ((angle % (2 * Math.PI)) + 2 * Math.PI) % (2 * Math.PI);
}
